import type { Server } from "@/app/servers/types";
import type { ApiClient } from "@/lib/api";

export const deleteServer = async (options: {
  client: ApiClient;
  serverId: string;
}) => {
  const { client, serverId } = options;
  await client.delete<Server>(`/workers/${serverId}`);
};
